import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import AdditionalPassengerDetails from './AdditionalPassengerDetails'

type PassengersProps = {
  numPassengers: number
  setNumPassengers: (cb: (val: number) => number) => void
  clientId?: number
}

const Passengers = ({ numPassengers, clientId }: PassengersProps) => {
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'passengers',
  })

  useEffect(() => {
    if (fields.length > numPassengers) {
      remove(fields.length - 1)
    }
  }, [numPassengers])

  const AddPassengerNameButton = () => {
    if (fields.length < numPassengers) {
      return <Button onClick={() => append({})}>Add passenger name</Button>
    }
    return <></>
  }
  return (
    <>
      <AddPassengerNameButton />
      {fields.map((field, index) => (
        <AdditionalPassengerDetails
          namePrefix={`passengers.${index}`}
          key={field.id}
          clientId={clientId}
          onRemove={() => {
            remove(index)
          }}
        />
      ))}
    </>
  )
}

export default Passengers
